import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import FullPageSpinner from '@/components/feedback/FullPageSpinner'
import Page from '@/components/layouts/Page'
import { ConfigVersionDisplayReadOnly } from '@/features/controller/configuration/components/ConfigVersionDisplayReadOnly'
import { useControllerConfigVersionQuery } from '@/features/controller/configuration/hooks/useControllerConfigVersionQuery'
import { getControllerConfigType } from '@/features/controller/configuration/utils/controllerConfigTypes'
import { ControllerRouteInformation } from '@/features/controller/constants'
import NavigateToError from '@/features/error/pages/NavigateToError'

export function ConfigVersionViewPage() {
  const { controllerId, versionId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { configVersion, isLoading } = useControllerConfigVersionQuery(versionId!, {
    enabled: Boolean(versionId),
  })

  if (!controllerId || !versionId) {
    return <NavigateToError statusCode={404} />
  }

  if (isLoading) {
    return <FullPageSpinner />
  }

  if (!configVersion) {
    return <NavigateToError statusCode={404} />
  }

  const configType = getControllerConfigType(configVersion.configurationTypeId)

  const handleVersionChange = (newVersionUuid: string) => {
    // Update URL without a page reload
    navigate(ControllerRouteInformation.CONTROLLER_CONFIG_VIEW.navigationPath(controllerId, newVersionUuid), {
      replace: true,
    })
  }

  return (
    <Page
      pageHeaderProps={{
        pageTitle: `${configType.name} ${t('controllers.configuration.version.version')}`,
        breadcrumbItems: [
          {
            text: t('controllers.controller'),
            to: ControllerRouteInformation.CONTROLLER_DETAILS.navigationPath(controllerId),
          },
          {
            text: configType.name,
            to: ControllerRouteInformation.CONTROLLER_CONFIG_TYPED.navigationPath(controllerId, configType.id),
          },
        ],
      }}
    >
      <ConfigVersionDisplayReadOnly
        configVersion={configVersion}
        controllerId={controllerId}
        onVersionChange={handleVersionChange}
      />
    </Page>
  )
}
